module.exports = "https://trybtryb-legacy.web.app/img/logout.d2e55e8f.svg";